import { type BasicInfo, EVENT_STATUS, type Gallery, type Performers } from '@/types';

export const isEventEnded = (status: string): boolean => {
  return status === EVENT_STATUS.ENDED || status === EVENT_STATUS.COMPLETED;
};

export const isEventLive = (status: string): boolean => {
  return status === EVENT_STATUS.LIVE || status === EVENT_STATUS.STARTED;
};

export const isEventCancelled = (status: string): boolean => {
  return status === EVENT_STATUS.CANCELLED;
};

export const isEventPostponed = (status: string): boolean => {
  return status === EVENT_STATUS.POSTPONED;
};

export const isEventSalesEnded = (status: string): boolean => {
  return status === EVENT_STATUS.DELETED;
};

/** Path segment after /e/ in the event URL, falling back to basicInfo.id. */
export const getEventSlugFromBasicInfo = (basicInfo: BasicInfo): string => {
  try {
    const match = new URL(basicInfo.url).pathname.match(/^\/e\/([^/]+)/);
    if (match) return match[1];
  } catch {
    // invalid or missing URL – fall through
  }
  return basicInfo.id ?? '';
};

export const getViewDetailsUrl = (basicInfo: BasicInfo | null): string | null => {
  if (!basicInfo || !isEventEnded(basicInfo.status) || !basicInfo.url) {
    return null;
  }
  return `${basicInfo.url}?viewDetails=true`;
};

export const getCarouselItems = (gallery?: Gallery) => {
  return (
    gallery?.images?.map(({ croppedLogoUrl480, croppedLogoUrl600, croppedLogoUrl940 }) => ({
      croppedLogoUrl480,
      croppedLogoUrl600,
      croppedLogoUrl940,
    })) ?? []
  );
};

export const hasPerformers = (performers?: Performers): boolean => {
  return (
    (Array.isArray(performers?.headliners) && (performers?.headliners?.length ?? 0) > 0) ||
    (Array.isArray(performers?.supporters) && (performers?.supporters?.length ?? 0) > 0)
  );
};
